import { api } from '@services';
import Tag, { ITag, ITagApiModel } from '@models/Tag.model';

interface ICreateTag {
  name: string;
  description?: string;
  tagCategoryId: string;
  equipmentsIds?: string[];
  softwareIds?: string[];
  miscellaneousIds?: string[];
  studioServiceIds?: string[];
}

const createTag = async (data: ICreateTag): Promise<ITag> => {
  const { data: tag } = await api.post<ITagApiModel>('/tags', data);
  return Tag.fromApiModel(tag);
};

export { createTag };
